/*
 * p80-tooltip – Accessible, reusable tooltip custom element.
 *
 * Load in any section / snippet:
 *   <link rel="stylesheet" href="{{ 'p80-tooltip.css' | asset_url }}" media="print" onload="this.media='all'">
 *   <noscript>{{ 'p80-tooltip.css' | asset_url | stylesheet_tag }}</noscript>
 *   <script src="{{ 'p80-tooltip.js' | asset_url }}" defer="defer"></script>
 *
 * Usage:
 *   <p80-tooltip data-tip="Helpful description">
 *     <button type="button">?</button>
 *   </p80-tooltip>
 *
 * Attributes:
 *   data-tip        – Tooltip text (required)
 *   data-position   – top | bottom | left | right (default: top)
 */

if (!customElements.get('p80-tooltip')) {
  customElements.define(
    'p80-tooltip',
    class P80Tooltip extends HTMLElement {
      constructor() {
        super();
        this.tooltipId = `p80-tip-${Math.random().toString(36).slice(2, 9)}`;
        this.trigger = null;
        this.bubble = null;

        this.showTip = this.showTip.bind(this);
        this.hideTip = this.hideTip.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
      }

      connectedCallback() {
        this.trigger = this.firstElementChild;
        if (!this.trigger) return;

        this.bubble = this.buildBubble();
        this.appendChild(this.bubble);

        this.trigger.setAttribute('aria-describedby', this.tooltipId);

        this.trigger.addEventListener('mouseenter', this.showTip);
        this.trigger.addEventListener('mouseleave', this.hideTip);
        this.trigger.addEventListener('focus', this.showTip);
        this.trigger.addEventListener('blur', this.hideTip);
        this.addEventListener('keydown', this.onKeyDown);
      }

      disconnectedCallback() {
        if (!this.trigger) return;
        this.trigger.removeEventListener('mouseenter', this.showTip);
        this.trigger.removeEventListener('mouseleave', this.hideTip);
        this.trigger.removeEventListener('focus', this.showTip);
        this.trigger.removeEventListener('blur', this.hideTip);
        this.removeEventListener('keydown', this.onKeyDown);
      }

      buildBubble() {
        const el = document.createElement('span');
        el.id = this.tooltipId;
        el.setAttribute('role', 'tooltip');
        el.className = 'p80-tooltip__bubble';
        el.textContent = this.dataset.tip || '';

        const pos = this.dataset.position;
        if (pos) el.dataset.position = pos;

        return el;
      }

      showTip() {
        this.bubble.setAttribute('data-visible', '');
      }

      hideTip() {
        this.bubble.removeAttribute('data-visible');
      }

      onKeyDown(e) {
        if (e.key === 'Escape') {
          this.hideTip();
        }
      }
    }
  );
}
